__webpack_require__.p = "/apps/deck/js/";